module.exports = __webpack_public_path__ + "static/media/functionalSticker-large.ade3ca1d.jpg";